import { z } from 'zod';

import i18n from '@/i18n';

export const TeamInviteCreateSchema = z.object({
    email: z.string().email(i18n.global.t('Vinaliga skriva ein rættan teldubústað.')),
    is_owner: z.boolean(),
});
